import * as React from 'react';
export var IconWarningFill = React.forwardRef(function IconWarningFill({ size = 24, ...other }, ref) {
    if (size === 16 || size === '16') {
        return /*#__PURE__*/ React.createElement('svg', {
            width: '16',
            height: '16',
            viewBox: '0 0 16 16',
            fill: 'none',
            ref: ref,
            focusable: false,
            ...other,
            'data-global-icon-size-sm': true
        }, /*#__PURE__*/ React.createElement('path', {
            fillRule: 'evenodd',
            clipRule: 'evenodd',
            d: 'M6.428 2.966c.644-1.291 2.486-1.292 3.13-.002l4.252 8.501a1.75 1.75 0 0 1-1.565 2.533H3.752a1.75 1.75 0 0 1-1.566-2.531l4.242-8.501Zm.814 3.788a.75.75 0 0 1 1.502 0V8.25a.75.75 0 0 1-1.502 0V6.754Zm1.502 3.996a.75.75 0 1 1-1.501 0 .75.75 0 0 1 1.5 0Z',
            fill: 'currentColor',
            'data-global-icon-size-sm': true
        }));
    }
    if (size === 24 || size === '24') {
        return /*#__PURE__*/ React.createElement('svg', {
            width: '24',
            height: '24',
            viewBox: '0 0 24 24',
            fill: 'none',
            ref: ref,
            focusable: false,
            ...other,
            'data-global-icon-size-md': true
        }, /*#__PURE__*/ React.createElement('path', {
            fillRule: 'evenodd',
            clipRule: 'evenodd',
            d: 'M9.542 5.52c1.014-2.027 3.906-2.027 4.92 0l5.249 10.5c.914 1.828-.416 3.979-2.46 3.979H6.754c-2.045 0-3.374-2.151-2.46-3.98L9.542 5.52Zm1.712 4.224a.749.749 0 1 1 1.497 0v3.504a.749.749 0 1 1-1.497 0V9.744ZM13 15.997a1 1 0 1 1-1.999.002A1 1 0 0 1 13 15.997Z',
            fill: 'currentColor',
            'data-global-icon-size-md': true
        }));
    }
    if (size === 32 || size === '32') {
        return /*#__PURE__*/ React.createElement('svg', {
            width: '24',
            height: '24',
            viewBox: '0 0 24 24',
            fill: 'none',
            ref: ref,
            focusable: false,
            ...other,
            'data-global-icon-size-lg': true
        }, /*#__PURE__*/ React.createElement('path', {
            fillRule: 'evenodd',
            clipRule: 'evenodd',
            d: 'M9.542 5.52c1.014-2.027 3.906-2.027 4.92 0l5.249 10.5c.914 1.828-.416 3.979-2.46 3.979H6.754c-2.045 0-3.374-2.151-2.46-3.98L9.542 5.52Zm1.712 4.224a.749.749 0 1 1 1.497 0v3.504a.749.749 0 1 1-1.497 0V9.744ZM13 15.997a1 1 0 1 1-1.999.002A1 1 0 0 1 13 15.997Z',
            fill: 'currentColor',
            'data-global-icon-size-lg': true
        }));
    }
});
